import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [isUserLoading, setIsUserLoading] = useState(true);

    useEffect(() => {
        const raw = localStorage.getItem('authUserData');
        if (raw) {
            try {
                setUser(JSON.parse(raw));
            } catch (_) {
                localStorage.removeItem('authUserData');
            }
        }
        setIsUserLoading(false);
    }, []);

    // userData comes from the backend: { token, refreshToken, user, isNewUser }
    const login = (userData) => {
        const stored = {
            token: userData.token,
            refreshToken: userData.refreshToken,
            // identity
            _id: userData.user?._id,
            username: userData.user?.username,
            email: userData.user?.email,
            photoUrl: userData.user?.photoUrl,
            isAdmin: userData.user?.isAdmin,
            // game data
            country: userData.user?.country || '',
            coins: userData.user?.coins || 0,
            onlineRanked: userData.user?.onlineRanked || {},
            totalPoints: userData.user?.totalPoints || 0,
            totalPointsArg: userData.user?.totalPointsArg || 0,
            emoji: userData.user?.emoji || '⚽',
        };
        setUser(stored);
        localStorage.setItem('authUserData', JSON.stringify(stored));
        if (userData.refreshToken) {
            localStorage.setItem('refreshToken', userData.refreshToken);
        }
    };

    // Refresh user data from backend (call after earning coins, rank changes, etc.)
    const refreshUser = async () => {
        const raw = localStorage.getItem('authUserData');
        if (!raw) return;
        const stored = JSON.parse(raw);
        if (!stored?.token) return;
        try {
            const backendURL = process.env.REACT_APP_BACKEND_URL || 'https://footy-tictactoe-production.up.railway.app';
            const res = await fetch(`${backendURL}/auth/refresh`, {
                method: 'POST',
                headers: { Authorization: `Bearer ${stored.refreshToken}` },
            });
            if (!res.ok) return;
            const data = await res.json();
            login({ token: data.token, refreshToken: data.refreshToken || stored.refreshToken, user: stored });
        } catch (_) { /* silent */ }
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('authUserData');
        localStorage.removeItem('refreshToken');
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, refreshUser, isUserLoading }}>
            {children}
        </AuthContext.Provider>
    );
}
